import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import LinearProgress from '../../../core/layout/LinearProgress';
import Separator from '../../../core/layout/Separator';
import Dialog from '../../../core/layout/Dialog';

const InstructionVideoUploadDialog = (props) => (
  <Dialog title="Video upload progress" isOpen={props.isOpen}>
    <Row>
      <Column size={12}>
        <LinearProgress
          value={props.uploadedPercentage || 0}
          color={props.uploadedPercentage && props.uploadedPercentage >= 100 ? 'green' : 'blue'}
          showInfo
        />
        <Separator size="lg" />
      </Column>
    </Row>
  </Dialog>
);

InstructionVideoUploadDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  uploadedPercentage: PropTypes.number,
};

InstructionVideoUploadDialog.defaultProps = {
  uploadedPercentage: 0,
};

export default InstructionVideoUploadDialog;
